const SET_BULK_CHANGE_RESULT = 'dofe-bo/bulk/SET_BULK_CHANGE_RESULT'

const initialState = {
  bulkChangeResult: {
    successfulCount: 0,
    unsuccessfulCount: 0,
    totalCount: 0,
    successfulIds: [],
    bulkErrorResults: []
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_BULK_CHANGE_RESULT:
      return {
        ...state,
        bulkChangeResult: action.data
      }
    default:
      return state
  }
}

export function setBulkChangeResult(data) {
  return {
    type: SET_BULK_CHANGE_RESULT,
    data
  }
}
